module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_89-38dee6437c7eb57032e0a0315a0221fa.png";